import * as React from 'react';
import { FoldersList } from '../../components/FoldersList';
import { useDispatch, useSelector } from 'react-redux';
import { selectCanLoadMore, selectFolders } from '../../selectors/folders';
import { CreateFolderContainer } from './create';
import { getFolders } from '../../thunk/favorites/getFolders';
import { selectFolder } from '../../actions/folders/actions';
import { unselectAll } from '../../actions/selected';
import { fetchFavoriteEntities } from '../../actions/favoriteEntities';
import { usePopstateEventQuery } from '../../hooks/browserHistory';

export function FoldersListContainer() {
  const dispatch = useDispatch();
  const canLoadMore = useSelector(selectCanLoadMore);
  const folders = useSelector(selectFolders);

  const handleLoadMoreClick = () => {
    dispatch(getFolders({ offset: folders.length, keepExisting: true }));
  };

  usePopstateEventQuery(queryParams => {
    const folderIdToSet = queryParams.folder || null;
    const folder = (folderIdToSet && folders.find(folderItem => folderItem.id === +folderIdToSet)) || null;

    dispatch(selectFolder({ folder }));
    dispatch(unselectAll());
    dispatch(fetchFavoriteEntities({ offset: 0 }));
  });

  return (
    <FoldersList
      folders={folders}
      create={<CreateFolderContainer />}
      showLoadMoreButton={canLoadMore}
      onLoadMoreButtonClick={handleLoadMoreClick}
    />
  );
}
